module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_redefine.js
// module id = 1322
// module chunks = 25